import {AbstractRepository} from './AbstractRepository'
import 'core-js/es6/array';

export class ConfigRepository extends AbstractRepository {
    config;

    constructor() {
        super();
        this.config = this.table('config');
    }

    findAll() {
        return new Promise(resolve => {
            this.transaction('rw', this.config, () => {
                this.config = this.config.toArray();
                resolve(this.config);
            }).catch(e => {
                alert(e.stack || e);
            });
        });
    }

    findById(id) {
        return new Promise(resolve => {
            this.transaction('rw', this.config, () => {
                this.config = this.config.where("id").equals(parseInt(id)).toArray();
                resolve(this.config);
            }).catch(e => {
                alert(e.stack || e);
            });
        });
    }

    findByCode(code) {
        return new Promise(resolve => {
            this.transaction('rw', this.config, () => {
                this.config = this.config.where("code").equals(code).toArray();
                resolve(this.config[0]);
            }).catch(e => {
                alert(e.stack || e);
            });
        });
    }

    update(config) {
        return new Promise(resolve => {
            this.transaction('rw', this.config, () => {
               resolve(this.config.update(config.id, {
                   code: config.code,
                   type: config.type,
                   value: config.value,
                   foreign: config.foreign,
                   cols: config.cols
                    }
                ));
            }).catch(e => {
                alert(e.stack || e);
            });
        });
    }

    add(code,title, description, type,value,foreign,cols) {
        return new Promise(resolve => {
            this.transaction('rw', this.config, async () => {
                let id = await this.config.add(
                    {
                        code: code,
                        type: type,
                        title: title,
                        description: description,
                        value: value,
                        foreign: foreign,
                        cols: cols
                    }
                );
                resolve({
                    id: id,
                    type: type,
                    title: title,
                    description: description,
                    value: value,
                    foreign: foreign,
                    cols: cols
                });
            }).catch(e => {
                alert(e.stack || e);
            });
        });
    }

    remove(id) {
        this.transaction('rw', this.config, async() => {
            await this.config.where("id").equals(id).delete();
        }).catch(e => {
            alert(e.stack || e);
        });
    }
}
